import Loadable from 'app/components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const LogoeditList = Loadable(lazy(() => import('./LogList')));
const ManageLog = Loadable(lazy(() => import('./ManageLog')));
const Unidentifylog = Loadable(lazy(() => import('./Unidentifylog')));
const Archivelog = Loadable(lazy(() => import('./Archivelog')));
const Addlog = Loadable(lazy(() => import('./Addlog')));

const LogRoutes = [
	{
		path: '/logedit',
		element: <LogoeditList />,
		auth: authRoles.admin,
	},
	{
		path: '/managelog',
		element: <ManageLog />,
		auth: authRoles.admin,
	},
	{
		path: '/unidentifylog',
		element: <Unidentifylog />,
		auth: authRoles.admin,
	},
	{
		path: '/archivelog',
		element: <Archivelog />,
		auth: authRoles.admin,
	},
	{
		path: '/addlog',
		element: <Addlog />,
		auth: authRoles.admin,
	},
];

export default LogRoutes;
